export enum EDocType {
  IDENTIFICATION_FRONT = 'IDENTIFICATION_FRONT',
  IDENTIFICATION2_FRONT = 'IDENTIFICATION2_FRONT',
  IDENTIFICATION_BACK = 'IDENTIFICATION_BACK',
  IDENTIFICATION2_BACK = 'IDENTIFICATION2_BACK',
  SIGNATURE = 'SIGNATURE',
  SELFIE = 'SELFIE'
}
